(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_ajax = {
    
    getThrobber: function(width='30%', height='auto') {
      return '<img class="weaver-ajax-loading" src="/themes/custom/nvcl/images/loading.gif" alt="Loading..." title="Loading..." style="width: ' + width + ' !important; height: ' + height + ' !important;" />';
    },

    attach: function (context, settings) {

      // ensures javascript runs only once per page load and not with every ajax call
      $(once('weaver_ajax', 'body', context)).each(function () {

        const weaver_ajax = Drupal.behaviors.weaver_ajax;

        // ALERTS moved to weaver_alerts.js
        
        ////////////////////////////////////////
        // COMBINED MENU

        const combinedMenuModal = document.getElementById('combined-menu');
        const combinedMenuModalBody = combinedMenuModal.querySelector('.modal-body');
        
        if (combinedMenuModal != null && combinedMenuModalBody != null) {

          $(combinedMenuModal).on('shown.bs.modal', function(e) {

            if (combinedMenuModalBody.classList.contains('content-loaded') == false) {

              combinedMenuModalBody.innerHTML = weaver_ajax.getThrobber();

              $.ajax({
                type: "POST",
                url: Drupal.url('nvcl/ajax/load-content/combined_menu'),
                dataType: 'json',
                success: function (result) {
                  combinedMenuModalBody.innerHTML = result.contents;
                  combinedMenuModalBody.classList.add('content-loaded');
                },
                error: function (status) {
                  // TODO error handling
                  console.log(status);
                }
              });
            }
          });
        }

        //////////////////////////////////////// 
        // FOOTER AUDIO
        // const footerAudioTriggers = document.querySelectorAll('[data-ajax="footerAudio"]');
        const footerAudioModal = document.getElementById('modal-relations-audio');
        const footerAudioModalBody = footerAudioModal.querySelector('.modal-body');

        if (footerAudioModal != null && footerAudioModalBody != null) {

          // footerAudioTriggers.forEach((footerAudioTrigger) => {

          $(footerAudioModal).on('shown.bs.modal', function(e) {
              
            if (footerAudioModalBody.classList.contains('content-loaded') == false) {

              footerAudioModalBody.innerHTML = weaver_ajax.getThrobber();

              $.ajax({
                type: "POST",
                url: Drupal.url('nvcl/ajax/load-content/footer_audio'),
                dataType: 'json',
                success: function (result) {
                  footerAudioModalBody.innerHTML = result.contents;
                  footerAudioModalBody.classList.add('content-loaded');
                },
                error: function (status) {
                  // TODO error handling
                  console.log(status);
                }
              });
            }
          });
        }

        ///////////////////////////////////////
        // FOOTER IMAGE
        const footerImageContainer = document.querySelector('[data-ajax="footerImage"]');

        if (footerImageContainer == null) {
          return;
        }
                
        if (footerImageContainer.classList.contains('content-loaded') == true) {
          return;
        }

        footerImageContainer.innerHTML = weaver_ajax.getThrobber();

        $.ajax({
          type: "POST",
          url: Drupal.url('nvcl/ajax/load-content/footer_image'),
          dataType: 'json',
          success: function (result) {
            footerImageContainer.innerHTML = result.contents;
            footerImageContainer.classList.add('content-loaded');
          },
          error: function (status) {
            // TODO error handling
            console.log(status);
          }
        });

        ///////////////////////////////////////
        // HERO IMAGE
        const heroImageContainers = document.querySelectorAll('[data-ajax="heroImage"]');

        // if (heroImageContainers != null) {
        //   return;
        // }

        heroImageContainers.forEach((heroImageContainer) => {

          let id = heroImageContainer.dataset.id;

          if (heroImageContainer.classList.contains('content-loaded') == true) {
            return;
          }

          heroImageContainer.innerHTML = weaver_ajax.getThrobber();

          $.ajax({
            type: "POST",
            url: Drupal.url('nvcl/ajax/load-hero-image/' + parseInt(id)),
            dataType: 'json',
            success: function (result) {
              heroImageContainer.innerHTML = '<img src="' + result.contents + '" loading="eager" />';
              heroImageContainer.classList.add('content-loaded');
            },
            error: function (status) {
              // TODO error handling
              console.log(status);
            }
          });
        });

        ///////////////////////////////////////
        // HOURS
        // Important to stop hours from lagging behind caching

        // Hours table
        const hoursTableContainers = document.querySelectorAll('[data-ajax="hoursTable"]');
        if (hoursTableContainers != null) {
          hoursTableContainers.forEach((hoursTableContainer) => {
            hoursTableContainer.innerHTML = weaver_ajax.getThrobber();

            $.ajax({
              type: "POST",
              url: Drupal.url('nvcl/ajax/load-content/hours_table'),
              dataType: 'json',
              success: function (result) {
                if (hoursTableContainer == null) {
                  return;
                }

                hoursTableContainer.innerHTML = result.contents;
              },
              error: function (status) {
                // TODO error handling
                console.log(status);
              }
            });

          });
        }

        // Hours today
        const hoursTodayContainers = document.querySelectorAll('[data-ajax="hoursToday"]');
        if (hoursTodayContainers != null) {
          hoursTodayContainers.forEach((hoursTodayContainer) => {
            hoursTodayContainer.innerHTML = weaver_ajax.getThrobber();

            $.ajax({
              type: "POST",
              url: Drupal.url('nvcl/ajax/load-content/hours_today'),
              dataType: 'json',
              success: function (result) {
                if (hoursTodayContainer == null) {
                  return;
                }

                hoursTodayContainer.innerHTML = result.contents;
              },
              error: function (status) {
                // TODO error handling
                console.log(status);
              }
            });

          });
        }

        ///////////////////////////////////////
        // MAILCHIMP
        // ajax load Mailchimp signup form
        const mailchimpTriggers = document.querySelectorAll('[data-ajax="mailchimpsubscriptionformfootersignupform"]');
        const mailchimpModal = document.getElementById('modal-mailchimp');

        if (mailchimpTriggers != null && mailchimpModal != null) {
          mailchimpTriggers.forEach((mailchimpTrigger) => {

            mailchimpTrigger.addEventListener('click', function() {

              let mailchimpModalBody = mailchimpModal.querySelector('.modal-body');

              // #TODO replace with nice animation
              if (mailchimpModalBody != null) {   
                mailchimpModalBody.innerHTML = weaver_ajax.getThrobber();
              }


              $.ajax({
                type: "POST",
                url: Drupal.url('nvcl/ajax/load-mailchimp-signup-block/mailchimpsubscriptionformfootersignupform'),
                dataType: 'json',
                success: function (result) {
                  if (mailchimpModalBody != null) {
                    mailchimpModalBody.innerHTML = result.contents;
                  }
                },
                error: function (status) {
                  // TODO error handling
                  console.log(status);
                }
              });

            });
          });

        }
      });
    }

  };


})(jQuery, Drupal, once);
